import _ from 'lodash';
import { mapGetters, mapState } from 'vuex';
import { moment, helper } from '~';
import StatsInfo from '@/components/rabbit/campaign-stats/stats-info/StatsInfo.vue';
import { GOAL_LEAD_GENERATION, MODES } from '@/util/constants';

export default {
  components: {
    'stats-info': StatsInfo,
  },
  computed: {
    ...mapState('genericConfig', ['config']),
    ...mapGetters('campaign', {
      campaign: 'currentCampaign',
      currentIteration: 'currentIteration',
    }),
    isOneOff() {
      if (_.get(this.campaign, 'mode', '') === MODES.oneoff) {
        return true;
      }
      return false;
    },
    colWidth() {
      const width = Object.keys(this.currentIterationStats).length > 3 ? 6 : 4;
      return `col-md-${width}`;
    },
    ...mapState('campaign', { iterationsLoading: 'iterationsLoading' }),
    stats() {
      return this.prepareStats(this.campaign, true);
    },
    currentIterationStats() {
      return this.prepareStats(this.currentIteration, false);
    },
    currentIterationFullMonthName() {
      if (this.currentIteration) {
        const date = moment(this.currentIteration.start_date);
        return date.format('MMMM');
      }
      return null;
    },
    currentIterationStartDay() {
      if (this.currentIteration) {
        return this.$t('fn.date', { timestamp: this.currentIteration.start_date });
      }
      return null;
    },
    isVideoType() {
      return this.campaign.type === 'video';
    },
    advancedStats() {
      return _.get(this.config, 'feature_use_advanced_statistics', null);
    },
  },
  methods: {
    statValue(key, value) {
      if (key === 'engagement_rate') {
        return `${value}%`;
      }
      if (key === 'frequency') {
        return value.toFixed(1);
      }
      return this.$t('fn.number', { value });
    },
    prepareStats(iteration, overall) {
      const stats = (typeof iteration.stats === 'string') ? JSON.parse(iteration.stats) : iteration.stats;

      const allFields = {
        reach: {
          title: this.$t('terms.stats.reach'),
          icon: 'people-reached',
          value: _.get(stats, 'reach', 0),
          details: null,
        },
        frequency: {
          title: this.$t('terms.stats.frequency'),
          icon: 'frequency',
          value: _.get(stats, 'frequency', 0),
          details: null,
        },
        clicks: {
          title: this.$t('terms.stats.clicks'),
          icon: 'clicks',
          value: _.get(stats, 'clicks', 0),
          details: null,
        },
        video_view: {
          title: this.$t('terms.stats.video_view'),
          icon: 'video',
          value: _.get(stats, 'video_view', 0),
          details: null,
        },
        leadgen_other: {
          title: this.$t('terms.stats.leadgen_other'),
          icon: 'leadgen_other',
          value: _.get(stats, 'leadgen_other', 0),
          details: null,
        },
        engagement_rate: {
          title: this.$t('terms.stats.engagement_rate'),
          icon: 'engagement_rate',
          value: this.getEnganementRate(stats),
          details: null,
        },
        receive_offer: {
          title: this.$t('terms.stats.receive_offer'),
          icon: 'receive_offer',
          value: _.get(stats, 'receive_offer', 0),
          details: null,
        },
        unique_clicks: {
          title: this.$t('terms.stats.unique_clicks'),
          icon: 'unique_clicks',
          value: _.get(stats, 'unique_clicks', 0),
          details: null,
        },
        post_engagement: {
          title: this.$t('terms.stats.post_engagement'),
          icon: 'post_engagement',
          value: _.get(stats, 'post_engagement', 0),
          details: helper.getCampaignStatsDetails(
            'post_engagement', stats, this.campaign.campaign_rule.goal_type, this.campaign.type),
        },
        page_engagement: {
          title: this.$t('terms.stats.page_engagement'),
          icon: 'page_engagement',
          value: _.get(stats, 'page_engagement', 0),
          details: null,
        },
        impressions: {
          title: this.$t('terms.stats.impressions'),
          icon: 'impressions',
          value: _.get(stats, 'impressions', 0),
          details: null,
        },
        outbound_clicks: {
          title: this.$t('terms.stats.outbound_clicks'),
          icon: 'outbound_clicks',
          value: _.get(stats, 'outbound_clicks', 0),
          details: null,
        },
        total_clicks: {
          title: this.$t('terms.stats.total_clicks'),
          icon: 'total_clicks',
          value: _.get(stats, 'clicks', 0),
          details: helper.getCampaignStatsDetails(
            'total_clicks', stats, this.campaign.campaign_rule.goal_type, this.campaign.type),
        },
        landing_clicks: {
          title: _.get(this, 'campaign.campaign_rule.goal_type', '') === GOAL_LEAD_GENERATION
            ? this.$t('terms.stats.form_openings')
            : this.$t('terms.stats.landing_clicks'),
          icon: 'clicks',
          value: _.get(stats, 'link_clicks', 0),
          details: null,
        },
      };

      const usedFields = helper.getDisplayedStatsKeys(
        this.campaign.campaign_rule.goal_type,
        this.advancedStats,
        overall,
      );
      if (this.isVideoType) {
        usedFields.push('video_view');
      }
      const result = [];
      usedFields.forEach(fieldName => {
        if (allFields[fieldName]) {
          result.push({
            ...allFields[fieldName],
            slug: fieldName,
          });
        }
      });

      return result;
    },
    getEnganementRate(stats) {
      if (stats && stats.reach > 0) {
        return parseFloat((stats.clicks / stats.reach) * 100).toFixed(2);
      }
      return 0;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/rabbit/campaign-stats/CampaignStats.js